import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';

export const formHasElementId = (formConfig: FormConfig | undefined, elementId: string): undefined | boolean => {
    if (!formConfig) {
        return;
    }

    let hasGivenElement = false;
    for (let i = 0; i < formConfig.pages.length; i++) {
        const hasElement = !!formConfig.pages[i].elements.find((element) => element.elementId === elementId);
        if (hasElement) {
            hasGivenElement = true;
            break;
        }
    }

    return hasGivenElement;
};
